import request from '@/utils/request'

export function logsItems (params) {
  return request({
    url: '/amrep/logs/items',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/logs.js